import ServiceBase from "base/baseService"
import queryString from "query-string"

export default class MunicipioService extends ServiceBase {

    title = "Município"
    pluralTitle = "Municípios"
    url = '/cadastro/pessoa/municipio'
    frontUrl = '/cadastro/pessoa/pessoa/municipio/municipio'
    frontUrlList = '/cadastro/pessoa/pessoa/municipio/municipiolist'
    primaryKey = 'codigo_muni'

    async listByAutoComplete(text) {

        text = (text ?? '').trim()

        if (!text) return

        const search = { page: 1, perPage: 6, filtertype: 'combo' }

        search.descricao_muni = `${text}%`

        return await this.list('?' + queryString.stringify(search))

    }

}

